/**
 * Slider Testimonials script
 */
class Bookero_SliderTestimonials {
  constructor (wrapper) {
    this.sliderWrapper = wrapper;
    this.initState();
    this.initEvents();
  }

  initState () {
    this.dotsList = this.sliderWrapper.find('.slider-testimonials-dots-inner');
    this.dots = this.sliderWrapper.find('.dot');
    this.prevBtn = this.sliderWrapper.find('.prev');
    this.nextBtn = this.sliderWrapper.find('.next');
    this.list = this.sliderWrapper.find('.slider-testimonials-list');
    this.items = this.list.find('.slider-testimonials-item');
    this.itemsPerPage = 11;
    this.currentItem = 5;
    this.animationInProgress = false;
  }

  initEvents () {
    this.swipeEffect = new Hammer(this.sliderWrapper[0]);

    for (let i = 0; i < this.dots.length; i++) {
      this.dots.eq(i).on('click', e => {
        e.preventDefault();

        if (this.animationInProgress) {
            return;
        }

        this.currentItem = i;
        this.animationInProgress = true;
        this.dots.removeClass('is-active');
        this.dots.eq(this.currentItem).addClass('is-active');
        this.dotsList.css('margin-left', (-115 * this.currentItem) + "px");
        this.list.css('margin-left', (-100 * this.currentItem) + "%");

        setTimeout(() => {
          this.animationInProgress = false;
        }, 100);
      });
    }

    this.nextBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem++;
      this.animationInProgress = true;

      if (this.currentItem >= this.dots.length) {
        this.currentItem = 0;
      }

      this.dots.removeClass('is-active');
      this.dots.eq(this.currentItem).addClass('is-active');
      this.dotsList.css('margin-left', (-115 * this.currentItem) + "px");
      this.list.css('margin-left', (-100 * this.currentItem) + "%");

      setTimeout(() => {
        this.animationInProgress = false;
      }, 550);
    });

    this.prevBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem--;
      this.animationInProgress = true;

      if (this.currentItem < 0) {
        this.currentItem = this.dots.length - 1;
      }

      this.dots.removeClass('is-active');
      this.dots.eq(this.currentItem).addClass('is-active');
      this.dotsList.css('margin-left', (-115 * this.currentItem) + "px");
      this.list.css('margin-left', (-100 * this.currentItem) + "%");

      setTimeout(() => {
        this.animationInProgress = false;
      }, 550);
    });

    this.swipeEffect.on('swipe', ev => {
      if (ev.type === 'swipe' && ev.direction === 2) {
        if (this.currentItem < this.dots.length - 1) {
          this.currentItem++;
        } else {
          this.currentItem = 0;
        }

        this.dots.eq(this.currentItem).trigger('click');
      }

      if (ev.type === 'swipe' && ev.direction === 4) {
        if (this.currentItem > 0) {
          this.currentItem--;
        } else {
          this.currentItem = this.dots.length - 1;
        }

        this.dots.eq(this.currentItem).trigger('click');
      }
    });
  }

  initRWD () {
      let desktopViewport = window.matchMedia('(min-width: 1040px)');
      let tabletViewport = window.matchMedia('(min-width: 650px) and (max-width: 1039px)');
      let mobileViewport = window.matchMedia('(max-width: 619px)');

      if (desktopViewport.matches) {
          this.itemsPerPage = 11;
      } else if (tabletViewport.matches) {
          this.itemsPerPage = 5;
      } else if (mobileViewport.matches) {
          this.itemsPerPage = 3;
      }

      this.toggleDotsVisibility();

      desktopViewport.addListener(mq => {
          if (mq.matches) {
              this.setItemsPerPage(11);
          }
      });

      tabletViewport.addListener(mq => {
          if (mq.matches) {
              this.setItemsPerPage(5);
          }
      });

      mobileViewport.addListener(mq => {
          if (mq.matches) {
              this.setItemsPerPage(3);
          }
      });
  }

  setItemsPerPage (numberOfItems) {
    this.currentItem = 0;
    this.itemsPerPage = numberOfItems;
    this.dots.removeClass('is-active');
    this.dots.eq(this.currentItem).addClass('is-active');
    this.list.css('margin-left', (-100 * this.currentItem) + "%");
    this.toggleDotsVisibility();
  }
}
